var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field search-container",
      attrs: {
        "v-tooltip": {
          content: "Search",
          placement: "bottom",
          classes: "fab-tooltip",
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "search-input-wrapper",
          class: { "is-dark": _vm.$theme.isDark },
        },
        [
          _c(
            "span",
            {
              staticClass:
                "search-icon material-symbols-rounded has-text-primary",
            },
            [_vm._v(" search ")]
          ),
          _c(
            "bulma-autocomplete",
            {
              ref: "searchInput",
              staticClass: "global-search-autocomplete",
              class: [_vm.$theme.name],
              attrs: {
                id: "global_search",
                placeholder: "Search the system...",
                data: _vm.groupedResults,
                "group-field": "groupLabel",
                "group-options": "items",
                field: "",
                loading: _vm.isLoading,
                "open-on-focus": true,
                "loading-text": "Searching...",
              },
              on: {
                select: _vm.onSelectResult,
                focus: _vm.onSearchFocus,
                blur: _vm.onSearchBlur,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("global-search-quote-card", {
                        attrs: {
                          "result-type": _vm.getResultType(props.option),
                          assessor: props.option.assessorName,
                          "claim-no": props.option.claimNo,
                          color: props.option.colour,
                          cost: props.option.totalIncGST,
                          "customer-name": props.option.customer,
                          "quote-id": props.option.id,
                          "quote-number": props.option.quoteNo,
                          pos: props.option.pos,
                          invoices: props.option.invoices,
                          rego: props.option.regoNo,
                          insurer: props.option.insurer,
                          "build-year": props.option.buildYear,
                          "make-model": props.option.makeModel,
                          "high-light": props.option.highlight,
                          "phone-no": props.option.phoneNo,
                          "job-stage": props.option.jobStage,
                          "job-stages-sub-stages": _vm.jobStagesSubStages,
                          "order-status": props.option.orderStatus,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "group",
                  fn: function (props) {
                    return [
                      _c("div", { staticClass: "s-group-header" }, [
                        _c("span", { staticClass: "s-group-label" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "material-symbols-rounded s-group-icon",
                            },
                            [_vm._v(_vm._s(_vm.getGroupIcon(props.group)))]
                          ),
                          _vm._v(" " + _vm._s(props.group) + " "),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            },
            [
              _c("template", { slot: "empty" }, [
                _vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "has-text-centered has-text-grey" },
                      _vm._l(3, function (n) {
                        return _c("global-search-skeleton-card", { key: n })
                      }),
                      1
                    )
                  : !_vm.isLoading &&
                    _vm.searchQuery &&
                    _vm.totalResultsCount === 0
                  ? _c(
                      "div",
                      { staticClass: "has-text-centered has-text-grey" },
                      [_vm._v(" No results found ")]
                    )
                  : _c(
                      "div",
                      { staticClass: "has-text-centered has-text-grey" },
                      [
                        _c("div", { staticClass: "mb-3" }, [
                          _vm._v(
                            " Search for quotes, customers, vehicles, etc. "
                          ),
                        ]),
                        _vm.isSearchFocused
                          ? _c("div", {
                              staticClass: "beta-info-panel p-3",
                              class:
                                _vm.$theme.name === "dark"
                                  ? "has-text-white"
                                  : "has-text-black",
                            })
                          : _vm._e(),
                      ]
                    ),
              ]),
            ],
            2
          ),
          _c(
            "button",
            {
              staticClass: "clear-search-button",
              attrs: {
                type: "button",
                "aria-label": "Clear search",
                title: "Clear search",
              },
              on: { click: _vm.clearSearch },
            },
            [_vm._v(" × ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }